import { Modal as CosmaModal } from 'is24-corecss';
import { Modal as Modals } from '@/components/common/display/modal/v3';
import type { BenefitModalProps } from '@/@types/benefitModalProps';
import { useIntl } from '@/i18n';
import { BenefitOverview } from '../shared/BenefitOverview';
import { campaigns } from '@/components/common/campaigns';
import useNavigationPaths from '@/customHooks/useNavigationPaths.hook';

const { V3: Modal } = Modals;

export const AdacUpsellModal = ({ onClose }: Pick<BenefitModalProps, 'onClose'>) => {
  const { navigateToBenefit } = useNavigationPaths();
  const { t } = useIntl();
  const discoverAdacBenefit = () => navigateToBenefit(campaigns.ADAC_MEIN_PLUS);

  return (
    <Modal isVisible onClose={onClose}>
      <Modal.Header>
        <Modal.Title>{t({ id: 'benefits.adac.headline' })}</Modal.Title>
        <Modal.CloseButton />
      </Modal.Header>
      <Modal.Content>
        <BenefitOverview />
      </Modal.Content>
      <Modal.Footer>
        <CosmaModal.FooterButton
          variant='filledBrand'
          label={t({ id: 'common.buttons.discoverWohnenPlus' })}
          onClick={discoverAdacBenefit}
        />
      </Modal.Footer>
    </Modal>
  );
};
